import { Injectable } from '@angular/core';
import { ApiFacadeService } from '@app/services/api-facade.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
	IIntegrationsResponse,
	INotificationTopicsResponse,
	ISaveTopicSubscriptionPayload,
	ISlackChannelsResponse,
	ITopicSubscription,
	ITopicSubscriptionsResponse,
} from '@core/services/integrations/integrations.interface';
import { IResponseMessage } from '@app/interfaces';

@Injectable({
	providedIn: 'root',
})
export class IntegrationApi {
	constructor(private apiFacade: ApiFacadeService) {}

	checkIntegrations(org_id: string): Observable<IIntegrationsResponse> {
		const url = 'integrations/check_integrations';

		return this.apiFacade.post<IIntegrationsResponse>(url, { org_id });
	}

	getSlackChannels(): Observable<string[]> {
		const url = 'integrations/get_slack_channels';

		return this.apiFacade.post<ISlackChannelsResponse>(url).pipe(map((data) => data.channels));
	}

	getNotificationTopics(): Observable<{ [p: string]: string }> {
		const url = 'integrations/get_notifications_topics';

		return this.apiFacade.get<INotificationTopicsResponse>(url).pipe(map((data) => data.topics));
	}

	getTopicSubscriptions(): Observable<ITopicSubscription> {
		const url = 'integrations/get_topics_subscriptions';

		return this.apiFacade.get<ITopicSubscriptionsResponse>(url).pipe(map((data) => data.subscriptions));
	}

	saveTopicSubscriptions(topics: ISaveTopicSubscriptionPayload): Observable<IResponseMessage> {
		const url = 'integrations/save_topics_subscriptions';

		return this.apiFacade.post<IResponseMessage>(url, { topics });
	}

	integrateSlack(code: string, org_id: string, redirect_uri: string): Observable<IResponseMessage> {
		const payload = { code, org_id, redirect_uri };
		const url = 'integrations/slack/integration';

		return this.apiFacade.post<IResponseMessage>(url, payload);
	}

	integrateTeams(hook: string, id: string): Observable<IResponseMessage> {
		const payload = { hook, id };
		const url = 'integrations/teams/integration';

		return this.apiFacade.post<IResponseMessage>(url, payload);
	}

	removeIntegration(integration: string): Observable<IResponseMessage> {
		const url = 'integrations/delete_integration/' + integration;

		return this.apiFacade.delete<IResponseMessage>(url);
	}
}
